import { render, staticRenderFns } from "./ActionsBibliothequeMail.vue?vue&type=template&id=5bf0f85e&"
import script from "./ActionsBibliothequeMail.vue?vue&type=script&lang=js&"
export * from "./ActionsBibliothequeMail.vue?vue&type=script&lang=js&"
import style0 from "./ActionsBibliothequeMail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports